import { useState } from "react";
import Vendedores from "./Vendedores";
import Clientes from "../views/Clientes";
import Ventas from "./Ventas";

const Comercial = ({ subVistaInicial = "Ventas" }) => {
  const [pestanaActiva, setPestanaActiva] = useState(subVistaInicial);

  return (
    <div className="container-fluid mt-4">
      {/* BARRA DE PESTAÑAS */}
      <div className="d-flex justify-content-center mb-4 sticky-top" style={{ zIndex: 1030 }}>
        <div className="btn-group rounded-pill overflow-hidden shadow-sm border border-primary">
          <button
            className={`btn ${pestanaActiva === "Ventas" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setPestanaActiva("Ventas")}
          >
            Ventas
          </button>
          <button
            className={`btn ${pestanaActiva === "Clientes" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setPestanaActiva("Clientes")}
          >
            Clientes
          </button>
          <button
            className={`btn ${pestanaActiva === "Vendedores" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setPestanaActiva("Vendedores")}
          >
            Vendedores
          </button>
        </div>
      </div>

      {/* CONTENIDO SEGÚN PESTAÑA */}
      <div className="mt-4">
        {pestanaActiva === "Ventas" && <Ventas />}
        {pestanaActiva === "Clientes" && <Clientes />}
        {pestanaActiva === "Vendedores" && <Vendedores />}
      </div>
    </div>
  );
};

export default Comercial;
